import React from 'react';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {Alert, Icon, Layout, Table, Badge, Button, Modal, Switch, message, Tooltip, Breadcrumb} from 'antd';

import AdminHeader from '../../components/AdminHeader/AdminHeader';
import Footer from '../../components/Footer/Footer';
import SettingsGeneralForm from '../../components/SettingsGeneralForm/SettingsGeneralForm';
import classes from './SettingsGeneral.css';

import isAuthenticated from '../../utils/isAuthenticated';
import { getSettingsGeneralRequest, deleteSettingsGeneralRequest, activateSettingsGeneralRequest } from '../../api/requests';
import { logout } from '../../reducers/user/actions';
import { getGeneralSettingsCreatePermission, getGeneralSettingsUpdatePermission, getGeneralSettingsDeletePermission } from '../../reducers/user/selectors';
import { withNamespaces } from 'react-i18next';

const routes = require('../../routes.json');

const { Content } = Layout;

class SettingsGeneral extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      settingsList: [],
      errorMessage: '',
      responseMessage: '',
      settingsEdit: null,
    };
  }

  async componentDidMount() {
    this.getSettingsList();
  }

  getSettingsList = async () => {
    this.setState({ errorMessage: null, isLoading: true, responseMessage: null });

    try {
      const { data } = await getSettingsGeneralRequest();
      this.setState({ settingsList: data });
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      this.setState({ subject: null, errorMessage: get(e, 'response.data.error', this.props.i18n.t('Error')) });
    }

    this.setState({ isLoading: false });
  };

  columns = [
    {
      dataIndex: 'name',
      key: 'name',
      title: this.props.i18n.t('Name'),
      render: (val, record) => (<span><Badge count={record.state} style={{ width: '56px', backgroundColor: record.state === 'active' ? '#52c41a' : '#777' }} /> &nbsp;{val}</span>)
    },
    {
      dataIndex: 'content',
      key: 'content',
      title: this.props.i18n.t('Content'),
    },
    {
      dataIndex: 'id',
      key: 'id',
      title: this.props.i18n.t('Actions'),
      render: (id, settings) => (<div className={classes.actions}>
        <Tooltip placement="topLeft" title={this.props.i18n.t('NamespaceSettingsGeneral:Edit Setting')}>
          <Icon type='edit' theme='filled' className={classes.actionIcon} onClick={this.onSettingsEdit(settings)} />
        </Tooltip>

        &nbsp;&nbsp;
        <div>
          <b></b><br/>
          <Tooltip placement="topLeft" title={this.props.i18n.t('NamespaceSettingsGeneral:Activate / Deactivate Setting')}>
            <Switch disabled={(settings.state === 'active' && !this.props.settingsDeletePermission) || (settings.state === 'inactive' && !this.props.settingsUpdatePermission) } className={classes.activateBtn} checked={settings.state === 'active'} onChange={this.onSwitchSettingsActivation(id, settings.state)} />
          </Tooltip>

        </div>
      </div>)
    },
  ];

  onSwitchSettingsActivation = (id, state) => async () => {
    try {
      if (state === 'active') {
        await deleteSettingsGeneralRequest(id);
      } else {
        await activateSettingsGeneralRequest(id);
      }

      message.success(this.props.i18n.t('Saved'));

      this.getSettingsList();
    } catch (e) {
      if (get(e, 'response.status') === 401) { this.props.logout();  return; }
      message.error('Error');
      console.log(e);
    }
  };

  onSettingsEdit = settings => () => {
    this.setState({ settingsEdit: settings });
  };

  onSettingsEditHide = () => {
    this.setState({ settingsEdit: null });
  };

  onSettingsEditSubmit = () => {
    this.setState({ settingsEdit: null }, this.getSettingsList);
  };

  addSettings = () => {
    this.setState({ settingsEdit: {} });
  };

  render() {
    const { settingsList, errorMessage, responseMessage, isLoading, settingsEdit } = this.state;
    const { settingsCreatePermission } = this.props;

    return (
        <div style={{ backgroundColor: '#FAFAFA' }}>
            <Layout className={classes.parentContainer}>

                <Content className={classes.content}>
                  <h3 className='headline-default'>{this.props.i18n.t('NamespaceSettingsGeneral:General Settings Management')}</h3>

                  <Breadcrumb>
                    <Breadcrumb.Item href='/admin/settings'>{this.props.i18n.t('Admin Settings')}</Breadcrumb.Item>
                    <Breadcrumb.Item>{this.props.i18n.t('NamespaceSettingsGeneral:General Settings Management')}</Breadcrumb.Item>
                  </Breadcrumb>
                  <br/>

                  {errorMessage && (<Alert type='error' message={errorMessage} />)}

                  {responseMessage && (<Alert type='success' message={responseMessage} />)}

                  {settingsCreatePermission && <div><Button type='primary' onClick={this.addSettings}>{this.props.i18n.t('NamespaceSettingsGeneral:Add setting')}</Button><br/><br/></div>}

                  <Table
                    columns={this.columns}
                    dataSource={settingsList}
                    loading={isLoading}
                    rowKey='id'
                    pagination={false}
                  />


                  <Modal
                    visible={!!settingsEdit}
                    onCancel={this.onSettingsEditHide}
                    footer={null}
                  >
                    {settingsEdit && <SettingsGeneralForm {...settingsEdit} isNew={settingsEdit && !settingsEdit.id} onSubmit={this.onSettingsEditSubmit} onCancel={this.onSettingsEditHide} />}
                  </Modal>

                </Content>

            </Layout>
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
  settingsCreatePermission: getGeneralSettingsCreatePermission(state),
  settingsUpdatePermission: getGeneralSettingsUpdatePermission(state),
  settingsDeletePermission: getGeneralSettingsDeletePermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SettingsGeneral)));



// WEBPACK FOOTER //
// ./src/containers/SettingsGeneral/SettingsGeneral.js